/* ================================================================
   ZZ MARTS — POLICY PAGE ENHANCEMENT
   ----------------------------------------------------------------
   Shopify renders /policies/* itself and ignores templates/policy.liquid
   entirely — see the long note at the top of assets/zz-policy.css. All
   we are given is:

     div.shopify-policy__container
       h1.shopify-policy__title
       div.shopify-policy__body

   So the contents rail, the header meta and the cross-links have to be
   built on the client. This runs once, does no network work, and every
   piece of it is additive: if the script never executes, the page is
   still the full policy text, correctly styled by the CSS.

   It deliberately does NOT rewrite the policy text. The body HTML is
   moved, never edited — legal copy should be exactly what the merchant
   pasted into Settings > Policies.
   ================================================================ */
(function () {
  'use strict';

  var POLICIES = [
    { url: '/policies/refund-policy',     label: 'Refund policy' },
    { url: '/policies/shipping-policy',   label: 'Shipping policy' },
    { url: '/policies/privacy-policy',    label: 'Privacy policy' },
    { url: '/policies/terms-of-service',  label: 'Terms of service' },
    { url: '/policies/contact-information', label: 'Contact information' }
  ];

  var LEGAL_NAME = 'Zam Zam Traders';
  var KHI = { phone: '0321 9221031', addr: 'Saddar (Regal), Karachi' };
  var LHR = { phone: '0308 3260009', addr: 'Mall Road, Lahore' };
  var HOURS = 'Monday to Saturday, 11:00 am to 8:30 pm. Closed Sunday.';

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function slug(text, i) {
    var s = String(text).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    return 'zzpol-' + (s || 'section') + '-' + i;
  }

  function init() {
    var box = document.querySelector('.shopify-policy__container');
    var title = document.querySelector('.shopify-policy__title');
    var body = document.querySelector('.shopify-policy__body');
    if (!box || !body || box.classList.contains('zzpol')) return;

    box.classList.add('zzpol');

    /* ---------- header ---------- */
    var head = el('div', 'zzpol__head');
    head.appendChild(el('span', 'zzpol__k', 'Legal'));
    if (title) head.appendChild(title);          // moved, not rebuilt

    var meta = el('div', 'zzpol__meta');
    meta.appendChild(el('span', null, 'Issued by <strong>' + LEGAL_NAME + '</strong>'));
    var when = document.lastModified;
    if (when) {
      var d = new Date(when);
      if (!isNaN(d)) {
        meta.appendChild(el('span', null, 'Last updated <strong>' +
          d.toLocaleDateString('en-GB', { month: 'long', year: 'numeric' }) + '</strong>'));
      }
    }
    head.appendChild(meta);
    box.insertBefore(head, box.firstChild);

    /* ---------- contents rail ---------- */
    var shell = el('div', 'zzpol__shell');
    var heads = body.querySelectorAll('h2');
    var toc = null;

    // One h2 is not a contents list, it is a heading. Two is the
    // smallest number where a rail earns its column.
    if (heads.length > 1) {
      toc = el('nav', 'zzpol__toc');
      toc.setAttribute('aria-label', 'On this page');
      toc.appendChild(el('div', 'zzpol__toc-t', 'On this page'));
      var ol = el('ol');
      Array.prototype.forEach.call(heads, function (h, i) {
        var text = (h.textContent || '').trim();
        if (!text) return;
        if (!h.id) h.id = slug(text, i + 1);
        var li = el('li');
        var a = el('a', null, text);
        a.href = '#' + h.id;
        li.appendChild(a);
        ol.appendChild(li);
      });
      toc.appendChild(ol);
      shell.appendChild(toc);
    }

    body.parentNode.insertBefore(shell, body);
    shell.appendChild(body);

    /* ---------- other policies + contact ---------- */
    var foot = el('div', 'zzpol__foot');
    var here = window.location.pathname.replace(/\/$/, '');

    var left = el('div');
    left.appendChild(el('h2', null, 'Other policies'));
    var ul = el('ul', 'zzpol__links');
    POLICIES.forEach(function (p) {
      var li = el('li');
      var a = el('a', null, p.label);
      a.href = p.url;
      if (p.url === here) a.setAttribute('aria-current', 'page');
      li.appendChild(a);
      ul.appendChild(li);
    });
    left.appendChild(ul);

    var right = el('div');
    right.appendChild(el('h2', null, 'Talk to a person'));
    right.appendChild(el('div', 'zzpol__contact',
      '<p>If anything here is unclear, ask before you order. We would rather ' +
      'answer a question than process a return.</p>' +
      '<p><strong>Karachi</strong><a href="tel:' + KHI.phone.replace(/ /g, '') + '">' +
      KHI.phone + '</a><br>' + KHI.addr + '</p>' +
      '<p><strong>Lahore</strong><a href="tel:' + LHR.phone.replace(/ /g, '') + '">' +
      LHR.phone + '</a><br>' + LHR.addr + '</p>' +
      '<p>' + HOURS + '</p>'));

    foot.appendChild(left);
    foot.appendChild(right);
    box.appendChild(foot);

    /* ---------- current section highlight ---------- */
    /* IntersectionObserver, not a scroll listener. A scroll handler here
       would run on every frame for a page that is pure reading. */
    if (toc && 'IntersectionObserver' in window) {
      var links = {};
      toc.querySelectorAll('a').forEach(function (a) {
        links[a.getAttribute('href').slice(1)] = a;
      });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          for (var id in links) links[id].classList.remove('is-current');
          if (links[e.target.id]) links[e.target.id].classList.add('is-current');
        });
      }, { rootMargin: '-80px 0px -70% 0px' });
      Array.prototype.forEach.call(heads, function (h) { if (h.id) io.observe(h); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
